export function createDefaultModule<T, U>(getModule: (m: U) => T) {
  return (module: U) => ({ default: getModule(module) });
}
